import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function NotFound() {
  useEffect(() => {
    document.title = 'Siden blev ikke fundet - Kristensen Byg og Montage ApS'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Den side, du leder efter, findes ikke eller er blevet flyttet. Gå tilbage til forsiden af Kristensen Byg og Montage ApS.'
      )
    }
  }, [])

  return (
    <div className="bg-warm-gray-50 min-h-[calc(100vh-20rem)] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center bg-white p-10 rounded-lg border border-warm-gray-200 shadow-sm">
        <div className="h-16 w-16 rounded-full bg-brand-green/10 text-brand-green flex items-center justify-center mx-auto mb-6">
          <i className="fa-light fa-compass-slash text-3xl" />
        </div>
        <span className="text-sm font-bold text-brand-green uppercase tracking-widest">Fejl 404</span>
        <h1 className="text-2xl sm:text-3xl font-bold uppercase tracking-wider text-anthracite mt-3 mb-4">
          Siden blev ikke fundet
        </h1>
        <p className="text-sm text-warm-gray-600 leading-relaxed mb-8">
          Beklager, men den side du leder efter findes ikke, er blevet slettet eller har fået ændret sin adresse.
        </p>
        <div className="flex flex-col gap-3">
          <Link
            to="/"
            className="w-full rounded bg-brand-green py-3 text-sm font-bold text-white shadow-sm hover:bg-brand-green-hover transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <i className="fa-light fa-house" />
            gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full rounded bg-warm-gray-100 border border-warm-gray-200 py-3 text-sm font-bold text-warm-gray-700 hover:bg-warm-gray-200 transition-colors duration-200"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  )
}
